import React from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';

import Stack from '@mui/material/Stack';

import Form, { FormTextField, FormSelect } from '@ts-core/core/components/FormV2';
import { Group } from 'modules/groups/types';

import { StudentFormInput } from '../../types/form';

interface StudentFormProps {
  isSubmitting?: boolean;
  submitError?: string;

  name?: string;
  email?: string;
  personalId?: string;

  groups: Group[];

  onSubmit: (data: StudentFormInput) => void;
}

const StudentForm = (props: StudentFormProps) => {
  const { isSubmitting, onSubmit, groups, name, personalId, email } = props;
  const intl = useIntl();

  const { handleSubmit, control, formState } = useForm<StudentFormInput>({
    defaultValues: {
      name,
      personalId,
      email,
    },
  });

  return (
    <Form
      sx={{ width: '100%' }}
      formState={formState}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isSubmitting}
      submitActionTitle={intl.formatMessage({ id: 'addStudentForm.button.add' })}
    >
      <Stack spacing={2}>
        <FormTextField
          control={control}
          name="name"
          disabled={!!name}
          fullWidth
          rules={{ required: true }}
          type="text"
          label={intl.formatMessage({ id: 'addStudentForm.field.name' })}
        />
        <FormTextField
          control={control}
          name="email"
          disabled={!!email}
          fullWidth
          rules={{ required: true }}
          type="email"
          label={intl.formatMessage({ id: 'addStudentForm.field.email' })}
        />
        <FormTextField
          control={control}
          name="personalId"
          disabled={!!personalId}
          fullWidth
          rules={{ required: true }}
          type="text"
          label={intl.formatMessage({ id: 'addStudentForm.field.personalId' })}
        />
        {groups.length > 0 && (
          <FormSelect
            control={control}
            items={groups}
            rules={{ required: true }}
            name="group"
            itemValueKey="_id"
            itemTitleKey="name"
            label={intl.formatMessage({ id: 'addStudentForm.field.group' })}
          />
        )}
      </Stack>
    </Form>
  );
};

export default StudentForm;
